import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SidebarMenus from './SidebarMenus';
import { FaArrowRight } from "react-icons/fa6";
import { Offcanvas } from 'react-bootstrap';

import logo from '../assets/images/delpick.png'


function Sidebar() {
  const dispatch = useDispatch();
  const datas = useSelector((state) => state.seller_panel.User);
  const [showCanvas, setShowCanvas] = useState(false);

  const handleCloseCanvas = () => setShowCanvas(false);
  const handleShowCanvas = () => setShowCanvas(true);

  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    // const content = document.getElementById('content-wrapper');
    //   setIsToggled(!isToggled);
    //   if (isToggled == "true"){
    //     content.classList.add("preview1");
    // } else{
    //     content.classList.add("preview");
    // }
    dispatch({
      type: "Login",
      Login: {
        User: {
          ...datas, ...{ toggle: !isToggled }
        }
      }
    })
  };

  return (
    <div className={isToggled ? 'toggled' : ''} id="wrapper">

      <button className='seller_canva_button d-lg-none' onClick={handleShowCanvas}>
        <FaArrowRight />
      </button>

      <aside id="sidebar-wrapper">
        {/* <div class="sidebar-brand">
        <h2>Logo</h2>
      </div> */}
        <SidebarMenus />
      </aside>

      <div id="navbar-wrapper">
        <nav class="navbar navbar-inverse">
          <div class="container-fluid">
            <div class="navbar-header">
              {/* <a href="#" class="navbar-brand" id="sidebar-toggle" onClick={handleToggle}><i class="fa fa-bars"></i></a> */}
            </div>
          </div>
        </nav>
      </div>

      <Offcanvas
        show={showCanvas}
        onHide={handleCloseCanvas}
        className="seller_offcanva d-lg-none"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={logo} className='img-fluid' alt='logo' />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SidebarMenus />
        </Offcanvas.Body>
      </Offcanvas>

    </div>
  )
}

export default Sidebar